import mutations from './mutations';
import actions from './actions';


const authModule = {
    namespaced: true,
    state: {
        //authentication: undefined
        //token:undefined,
        //user:undefined
        
    },
    mutations,
    actions
};

export default authModule;
